/**
 * Single source of truth for permission types and actions.
 * Must match backend PermissionType and PermissionAction enums.
 */

export const PERMISSION_TYPES = [
	"branches",
	"categories",
	"company",
	"customers",
	"dashboard",
	"departments",
	"expenses",
	"inventory",
	"notifications",
	"paymentMethods",
	"pos",
	"products",
	"purchases",
	"reports",
	"returns",
	"roles",
	"recipes",
	"sales",
	"settings",
	"suppliers",
	"taxes",
	"users",
	"cashierCatalog",
	"cashierSession",
	"cashierDrawer",
	"cashierHold",
	"cashierCustomer",
	"cashierDiscount",
	"cashierReturn",
	"cashierCoupon",
	"cashierStoreCredit",
	"cashierGiftCard",
	"cashierLoyalty",
	"cashierSplitBill",
	"cashierReceipt",
] as const;

export type PermissionType = (typeof PERMISSION_TYPES)[number];

/** Must match backend PermissionAction enum. */
export type PermissionAction = "create" | "read" | "update" | "delete" | "export" | "approve";
